import { UIElement } from '../ui-element';

export class VolumeIndicatorFillElement extends UIElement {
  static readonly tagName = 'media-volume-indicator-fill';
}
